module.exports = __webpack_public_path__ + "img/mico-product-listing.186e7277.jpg";